
import { v4 as uuid } from "uuid";
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  emits: ["deleted"],
  data() {
    return {
      name: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    submit: function () {
      this.$emit("deleted", {});
      this.name = "";
      const el = this.$refs["closeBtn"] as any;
      el.click();
    },
  },
});
